import { Button, Cascader, Tooltip } from 'antd'
import CustomSpin from '../../elements/CustomSpin'
import React from 'react'
import Api from '../../api/Corporates/Accounts'
import withSpinning from '../../elements/HOC/withSpinning'
import { compose } from 'recompose'
import { isEmpty, get } from 'lodash'
import { unflatten } from '../../modules/Utils'
import useFetchList from '../../elements/Hooks/useFetchList'

const Enhanced = compose(withSpinning)(Cascader)
const api = new Api()

function AccountsCascader(props) {
  const { company, center, parentName, codeMin, codeMax } = props
  const { fetch, fetching, list } = useFetchList(
    () => api.list(company, center),
    [company, center],
    false,
    undefined
  )
  let options = unflatten(list.map((a) => ({ ...a, label: `${a.code} ${a.name}` })))
  if (parentName && !isEmpty(options))
    options = get(
      options.filter((o) => o.name === parentName),
      '[0]children'
    )

  if (codeMin && !isEmpty(options))
    options = get(
      options.filter((o) => o.code > codeMin),
      '[0]children'
    )

  return (
    <Tooltip
      placement="top"
      mouseEnterDelay={1}
      mouseLeaveDelay={0.5}
      overlayStyle={{ background: 'white' }}
      title={
        <Button
          size={props.size}
          style={{ backgroundColor: 'Transparent', color: 'white' }}
          icon="retweet"
          onClick={fetch}>
          Refresh dropdown
        </Button>
      }
      trigger="hover">
      <CustomSpin spinning={fetching}>
        <Cascader
          data-testid={props['data-testid']}
          style={{ width: '100%' }}
          options={options}
          showSearch
          allowClear={true}
          fieldNames={{ label: 'label', value: '_id', children: 'children' }}
          placeholder={'Select an option'}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          {...props}
        />
      </CustomSpin>
    </Tooltip>
  )
}

export default AccountsCascader
